import React from "react";
import * as s from "./education.module.less"
import {Divider} from "../divider";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import {useTranslation} from "gatsby-plugin-react-i18next";
export const Education = ({
	educationData,
	certificateImages,
}) => {
	const {
		t
	} = useTranslation()
	return (
		<div className={ s.education }>
			<h2>{ t("cv.education") }</h2>
			<ul>
				{ educationData.map((edu) => {
					const certificate = certificateImages.edges.filter((elem) => elem.node.frontmatter.name === edu.title)[0]
					const title = certificate ? `${edu.time} | ${certificate.node.frontmatter.short.toUpperCase()}: ${edu.title}` : `${edu.time} | ${edu.title}`
					return (
						<>
							{ certificate && (
								<GatsbyImage
									className={s.certificate}
									image={getImage(certificate.node.frontmatter.imagePath)}
								/>
							)}
							<li>{ title }
								 <span className={ s.description }>{ edu.description }</span>
							</li>
						</>
					)
				})}
			</ul>
			<Divider/>
		</div>
	)
}
